import fasYuthica1 from "./fas-yuthica (1).webp";
import fasYuthica2 from "./fas-yuthica (2).webp";
import fasYuthica3 from "./fas-yuthica (3).webp";
import fasYuthica4 from "./fas-yuthica (4).webp";

const fasyuthica = [fasYuthica1, fasYuthica2, fasYuthica3, fasYuthica4];

export default fasyuthica;
